module.exports = __webpack_public_path__ + "img/operate_team.0c8079bb.png";